export default __webpack_public_path__ + "static/media/012_photo.b68dce3c.jpg";